import React from 'react';

export class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error("Global Error Caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-8 bg-rose-50 text-rose-900 min-h-screen font-mono">
          <h1 className="text-2xl font-bold mb-4">Sistem Mengalami Error (Crash)</h1>
          <p>Tolong screenshot layar ini dan kirimkan ke Asa (Developer):</p>
          
          <div className="mt-4 p-4 bg-white border border-rose-300 overflow-x-auto rounded-lg shadow-sm">
            <h2 className="font-bold text-rose-700">{this.state.error && this.state.error.toString()}</h2>
            <br />
            <pre className="text-xs whitespace-pre-wrap text-slate-700">
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </pre>
          </div>
          
          <button 
            onClick={() => window.location.reload()} 
            className="mt-6 px-4 py-2 bg-rose-600 text-white rounded hover:bg-rose-700 font-bold"
          >
            Muat Ulang Halaman (Refresh)
          </button>
        </div>
      );
    }

    return this.props.children; 
  }
}
